export default function CareersPage() {
  window.location.href = "https://mightymeals.bamboohr.com/jobs/";
  return null;
}